import { useEffect, useState } from "react";
import { CustomLoading } from "./CustomLoading";
import { Card, Line } from "ktm-ui";
import "../styles/Settings.css";
import EditGeneralSettingModal from "./EditGeneralSettingModal";


const DependentSettings = ({ policyId }) => {
    const [loading, setLoading] = useState(true);
    const [showEditGeneralModal, setShowEditGeneralModal] = useState(false);
    const [allowDependentEdit, setAllowDependentEdit] = useState(null);

    useEffect(() => {
        getAllowDependentEdit();
    }, []);

    useEffect(() => {
        getAllowDependentEdit();
    }, [allowDependentEdit]);

    const openEditGeneralModal = () => {
        setShowEditGeneralModal(true);
    }

    const getAllowDependentEdit = async () => {
        let response = await fetch("/api/Settings/checkallowedependentedit?policyId=" + policyId, { method: "GET" });
        let data = await response.json();
        if (data.success === false) {
            alert(data.message);
            return;
        }
        setAllowDependentEdit(data.isAllowDepEdit.eligibility);
        setLoading(false);
    }

    const updateAllowDependentEdit = async (eligibility) => {
        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ policyId: policyId, eligibility: eligibility }),
        };

        let response = await fetch("/api/Settings/updateallowdependentedit", requestOptions);
        let data = await response.json();
        if (data.success === false) {
            alert(data.message);
            return;
        }
        await getAllowDependentEdit();
    }

    let editGeneralModal = null;
    if (showEditGeneralModal) {
        editGeneralModal = (
            <EditGeneralSettingModal
                modalLabel={"Edit General"}
                options={["Yes", "No"]}
                showEditModal={showEditGeneralModal}
                selectedOption={allowDependentEdit}
                setSelectedOption={updateAllowDependentEdit}
                closeModal={() => setShowEditGeneralModal(false)}
                dropdownLabel={"Allow Dependent Edits by Employee:"}
            />
        );
    }

    let contents = null;
    if (loading) {
        contents = (<CustomLoading />);
    } else {
        contents = (
        <div className="appearance-setting-container">
            {editGeneralModal}
            <Card
                className="general-setting"
                label="General"
                actions={<><a href="#" className="RT-Link" onClick={openEditGeneralModal}>Edit</a></>}
            >
                <Line>
                    <div className="RT-Static-Field">
                        <div className='RT-Static-Field__label'>Allow Dependent Edits by Employee:</div>
                        <div className='RT-Static-Field__content'>{allowDependentEdit}</div>
                    </div>
                </Line>
            </Card>
        </div>
        );
    }

    return (
        <div className="appearance-settings">
        {contents}
        </div>
    );
}

export default DependentSettings;